import React, { useEffect, useState } from "react";
import clsx from "clsx";

import Flicking from "@egjs/react-flicking";
import { AutoPlay } from "@egjs/flicking-plugins";
import { BannersGetBannerTypeEnum, OutBannerDTO } from "@app/bf-api";
import { RelAttributes } from "@app/constants";
import { useAppSelector } from "@app/redux/store";
import { bannersGetApi } from "@app/middleware/api/banners-get.api";
import { shuffleArray } from "@app/util/array";

import styles from "./search-banners.module.scss";

export interface ISearchBannersProps {
  className?: string;
}

const SearchBanners = ({ className }: ISearchBannersProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const { banners } = useSearchBanners();

  if (!banners || banners.length === 0) return null;

  return (
    <div className={clsx(styles.root, className)} style={{ "--banner-count": banners.length } as any}>
      {banners.length > 1 && (
        <div className={styles.dots}>
          {banners.map((_, i) => (
            <div key={i} className={clsx(styles.dot, activeIndex === i && styles.activeDot)} />
          ))}
        </div>
      )}
      <Flicking
        cameraClass={styles.slider}
        disableOnInit
        circular
        plugins={[
          new AutoPlay({
            duration: 5000
          })
        ]}
        onWillChange={e => setActiveIndex(e.index)}
      >
        {banners.map((banner, index) => (
          <a
            key={index}
            className={styles.banner}
            href={`/out/banner/${banner?.slug}/`}
            rel={RelAttributes.SPONSORED}
            target="_blank"
          >
            <img src={banner.bannerImage?.url} alt={banner.bannerImage?.alt} className={styles.image} />
          </a>
        ))}
      </Flicking>
    </div>
  );
};

export { SearchBanners };

const useSearchBanners = () => {
  const { platform } = useAppSelector(state => state.platform);
  const [banners, setBanners] = useState<OutBannerDTO[]>([]);

  useEffect(() => {
    if (!platform?.id) return;

    setShuffledBanners(platform?.id);
  }, [platform?.id]);

  const setShuffledBanners = async (platformId: number) => {
    const sBn = await bannersGetApi({ platformId, bannerType: BannersGetBannerTypeEnum.SEARCH });
    setBanners(shuffleArray(sBn || []));
  };

  return { banners };
};
